module.exports = __webpack_public_path__ + "static/img/son9_active.98592b09.jpg";